import script from "./FontsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FontsTable.vue?vue&type=script&setup=true&lang=js"

import "./FontsTable.vue?vue&type=style&index=0&id=c7c06e06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7c06e06"]])

export default __exports__